// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"6900c7cb","726":"02ce7346","787":"a29ffe9d"}[chunkId] + ".chunk.js";
};